<template>
<div class="withdraw">
	<van-nav-bar :title="$t('withdraw.title')" left-text="" @click-left="back()" left-arrow >
	  <template #right>
	    <span style="color: rgb(255, 255, 255);font-size: 1rem;"  @click="$router.push({path:'/WithdrawRecord'});">
	    	{{$t('withdraw.log')}}
	    </span>
	  </template>
	</van-nav-bar>
	<!---->
	<div class="top">
		<div class="bank-auto" v-if="hasBoundBank">
			<span>{{ selectedBankText }}</span>
		</div>
		
		<p class="types">
			{{$t('withdraw.method')}}
		</p>
	</div>
	<!-- 银行详细信息显示 -->
	<div class="top bank-detail" v-if="selectedBankDetail && hasBoundBank">
		<div class="bank-detail-item" v-if="selectedBankDetail.bank_name">
			<label>银行名称：</label>
			<span>{{selectedBankDetail.bank_name}}</span>
		</div>
		<div class="bank-detail-item" v-if="selectedBankDetail.branch_name">
			<label>支店名称：</label>
			<span>{{selectedBankDetail.branch_name}}</span>
		</div>
		<div class="bank-detail-item" v-if="selectedBankDetail.branch_number">
			<label>支店番号：</label>
			<span>{{selectedBankDetail.branch_number}}</span>
		</div>
		<div class="bank-detail-item" v-if="selectedBankDetail.account_type">
			<label>账户类型：</label>
			<span>{{selectedBankDetail.account_type}}</span>
		</div>
		<div class="bank-detail-item" v-if="selectedBankDetail.account_number">
			<label>口座番号：</label>
			<span>{{selectedBankDetail.account_number}}</span>
		</div>
		<div class="bank-detail-item" v-if="selectedBankDetail.katakana">
			<label>カタカナ：</label>
			<span>{{selectedBankDetail.katakana}}</span>
		</div>
	</div>
	<div class="top center">
		<p>
			{{$t('withdraw.title')}} (JPY)
		</p>
		<div class="ipt">
			<p>
				JPY
			</p>
			<input v-model="withdraw_money" :placeholder="$t('withdraw.avmoney')+userInfo.money" type="number">
			<span  @click="allMoeny()">
				{{$t('common.all')}}
			</span>
		</div>
		<div class="sm">
			<div class="tips">
				<van-popover v-model="showPopover" trigger="click">
					<div class="popover-body" style="padding: 10px;">
						<p>1. {{$t('singleLimit')}}: {{$t('lowest')}} 100.00KRW, {{$t('highest')}} 1000000.00KRW</p>
						<p>2. {{$t('maxDailyWithdraw')}}: 10000000.00KRW</p>
						<p>3. {{$t('withdrawTimes')}}: 1{{$t('common.minenav')}} {{$t('maxDailyWithdraw')}} 999{{$t('times')}}({{$t('withdraw.title')}} {{$t('times')}} 500{{$t('times')}})</p>
						<p>4. {{$t('arrivalTime')}} {{$t('timedetail')}}</p>
					</div>
				  <template #reference @click="withdrawInfo()">
				    <van-icon name="question-o" size="1.3rem" />
				    {{$t('withdraw.limit')}}
				  </template>
				</van-popover>
			</div>
			<div class="syjf" >
				{{$t('withdraw.avmoney')}}：
				<span style="color: #d53dde;">
					{{ this.userInfo.money }} JPY
				</span>
			</div>
		</div>
	</div>
	<div class="btn">
		<a  @click="doWithdraw()">
			{{$t('withdraw.submit')}}
		</a>
	</div>
</div>
</template>

<script>
export default {
  data() {
    return {
      showPopover: false,
      withdraw_money:"",
      userInfo:{},
	  value1: 0,
	  banklist: [
		  { text: this.$t('withdraw.bank'), value: 0 }
		],
      withdrawRole:{},
      bankDetails: {}, // 存储所有银行的详细信息
      selectedBankDetail: null, // 当前选中的银行详细信息
      hasBoundBank: false,
      selectedBankText: ''
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserWithdrawRole(){
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_role'
      }).then(res=>{
		  console.log(res)
        if(res.code === 200){
          this.withdrawRole = res.data.data;
		  this.banklist = this.banklist.concat(res.data.list);
		  
		  // 解析并存储银行详细信息
		  if(res.data.list && res.data.list.length > 0){
			  const firstBank = res.data.list[0];
			  this.value1 = firstBank.value;
			  this.selectedBankText = firstBank.text || this.$t('withdraw.bank');
			  this.hasBoundBank = true;
			  
			  res.data.list.forEach(bank => {
				  if(bank.bankinfo){
					  try {
						  const bankInfoJson = JSON.parse(bank.bankinfo);
						  if(bankInfoJson && typeof bankInfoJson === 'object'){
							  this.bankDetails[bank.value] = {
								  bank_name: bankInfoJson.bank_name || '',
								  branch_name: bankInfoJson.branch_name || '',
								  branch_number: bankInfoJson.branch_number || '',
								  account_type: bankInfoJson.account_type || '',
								  account_number: bankInfoJson.account_number || '',
								  katakana: bankInfoJson.katakana || ''
							  };
						  }
					  } catch(e){
						  console.error('解析银行信息失败:', e, bank.bankinfo);
					  }
				  }
			  });
			  this.selectedBankDetail = this.bankDetails[this.value1] || null;
		  } else {
			  this.hasBoundBank = false;
			  this.$router.replace({path:'/BindCard'});
		  }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    onBankChange(value){
      // 当选择银行时，显示详细信息
      if(value && value != 0){
        this.selectedBankDetail = this.bankDetails[value] || null;
      } else {
        this.selectedBankDetail = null;
      }
    },
    allMoeny(){
      this.withdraw_money = this.userInfo.money;
    },
    doWithdraw(){
      if(this.withdraw_money <= 0){
        this.$toast(this.$t('withdraw.enterCorrectAmount'));
        return false;
      }else if(!this.hasBoundBank || this.value1 == 0){
		 this.$router.replace({path:'/BindCard'});
		 return false;
	  }else {
		this.dosubmit();
      }
    },
	dosubmit(){
		this.$http({
		  method: 'post',
		  data:{money:this.withdraw_money,bankid:this.value1},
		  url: 'user_set_withdraw'
		}).then(res=>{
		  if(res.code === 200){
		    location. reload()
		    this.$toast(res.msg);
		    this.getUserInfo();
		    this.getUserWithdrawRole();
		  }else if(res.code ===401){
		    this.$toast(res.msg);
		  }
		})
	},
    withdrawInfo(){
      this.showPopover = true;
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserWithdrawRole();
    }
  }
};
</script>

<style >
	/* @import "../../assets/css/basenew.css"; */
:export {
    gbcolor: linear-gradient(30deg,#7d76ef,#d63f8c)
}

.syjf {
    color: #2e0d67
}

.syjf span {
    color: #d53dde
}

.popover-body {
    font-size: .83333rem;
    width: 100%;
    color: #2e0d67
}

.popover-body p {
    text-align: justify;
    padding: .26667rem
}

.van-field {
    width: 50%;
    margin: 0 auto
}

/* .van-field .van-field__value {
    border: 1px solid #c5c5c5
} */

/* .van-field .van-field__value input {
    text-align: center
} */

.withdraw {
    width: 100%;
    height: 100%;
    background: url(/img/jf.png) no-repeat top / 100%, #fff;
}
.withdraw .van-field {
    width: 100%;
    margin: 0 auto;
}
.withdraw .van-nav-bar {
	position: relative;
    background: none
}

.withdraw .van-hairline--bottom:after {
    border-bottom-width: 0
}

.withdraw .top {
    width: 90%;
    background: #fff;
    margin: .6rem auto;
    padding: 1rem 5%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-radius: .33333rem;
    position: relative
}

.withdraw .top .van-dropdown-menu .van-cell__title {
    white-space: nowrap
}

.withdraw .top .types {
    position: absolute;
    right: 0
}

.withdraw .top .bank-auto {
    color: #442b89;
    font-size: 1rem;
    max-width: 70%;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.van-dropdown-menu__bar {
    box-shadow: none;
    height: auto
}

.van-dropdown-menu__title {
    font-size: 1rem;
	line-height: 2rem;
}
.van-cell{
	font-size: 1rem;
	line-height: 1rem;
}
.van-cell__value i{
	font-size: 1rem;
}
.withdraw .top .van-dropdown-item {
    width: 90%;
    left: 0;
    right: 0;
    margin: auto
}
.van-dropdown-menu__title::after {
    position: absolute;
    top: 50%;
    right: -0.58rem;
    margin-top: -0.58rem;
    border: 0.32rem solid;
    border-color: transparent transparent #dcdee0 #dcdee0;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    opacity: .8;
    content: '';
}
.withdraw .top .van-icon {
    color: #cc2996
}

.withdraw .top.center {
    flex-direction: column;
    align-items: flex-start
}

.withdraw .top p {
    margin-right: .66667rem;
    color: #442b89
}

.withdraw .top>.ipt {
    display: flex;
    width: 100%;
    padding: 1rem 0 0;
    justify-content: space-between;
	border:none;
    align-items: center
}

.withdraw .top>.ipt input {
    border: none;
    flex: 1;
    padding: .66667rem 0
}

.withdraw .top>.ipt p {
    padding-right: .66667rem
}

.withdraw .top>.ipt span {
    padding-left: 1rem;
    color: #735fb1
}

.withdraw .top .sm {
    width: 100%;
    padding: .66667rem 0;
    border-top: 1px solid #f5f6f7
}

.withdraw .top .sm .tips {
    text-align: right;
    width: 100%;
    color: #979799;
    padding: 0;
    font-size: .76667rem
}

.withdraw .top .sm .tips .van-popover__wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    color: #6c55ae
}

.withdraw .top .sm>div {
    width: 100%;
    text-align: left;
    padding-top: .66667rem
}

.withdraw .bank-detail {
    flex-direction: column;
    align-items: flex-start;
    padding: 1rem 5%;
    margin-top: 0.5rem;
}

.withdraw .bank-detail-item {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0.4rem 0;
    font-size: 0.9rem;
    border-bottom: 1px solid #f5f6f7;
}

.withdraw .bank-detail-item:last-child {
    border-bottom: none;
}

.withdraw .bank-detail-item label {
    color: #979799;
    min-width: 5rem;
    font-weight: normal;
    margin-right: 0.5rem;
}

.withdraw .bank-detail-item span {
    color: #442b89;
    flex: 1;
    word-break: break-all;
}

.withdraw .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: .66667rem;
    margin-top: 3.33333rem
}

.withdraw .btn a {
    background: linear-gradient(90deg,#e9557f,#7e55e9);
    width: 100%;
    color: #fff;
    padding: .86667rem 0;
    border-radius: 3.66667rem;
    font-size: .86667rem
}

</style>
